import React from 'react';
import Select from "react-select";
import * as utils from "../../../utils/fog";

export default class SelectCoverType extends React.Component {
    constructor(props) {
        super(props);
        this.state = {...props.formData};
    }

    onChange(value) {
        this.props.onChange(value);
    }


    render() {
        return (
            <div className="form-group field">
                <label className="control-label" htmlFor="root_coverType">
                    Cover Type
                </label>

                <Select
                    backspaceRemoves={false}
                    className="form-control"
                    name="root_coverType"
                    value={this.props.formData}
                    options={utils.getCoverTypesEnum('BUILT')}
                    isLoading={this.props.loading}
                    clearable={false}
                    onChange={this.onChange.bind(this)}
                    simpleValue
                    valueComponent={(props) => {
                        return (
                            <div className="Select-value" title={props.value.title}>
                                <span className="Select-value-label">
                                    {props.children === 'N/A' && <i style={{color: "#9a9a9a"}}>{props.children}</i>}
                                    {props.children !== 'N/A' && props.children}
                                </span>
                            </div>
                        )
                    }}
                />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/forms/fields/SelectCoverType.js